module.exports = __webpack_public_path__ + "img/print-example-stickers.e118a577.png";